import { useAtom } from '@reatom/npm-react'

import { delugeIdAtom } from '@root/entities/auth'
import { walletIdsAtom } from '@root/entities/wallet/atoms'

import { ALL_WALLETS, type UserTradingAnalyticsModel } from '../../atoms'

import { WalletSelector } from './wallet-selector'

// TODO: Maybe we should allow user to select multiple wallets?
export const WalletSelectorBlock = (props: {
  model: UserTradingAnalyticsModel
}) => {
  const { model } = props
  const [selectedWallets, setSelectedWallets] = useAtom(
    props.model.selectedWalletsAtom,
  )
  const selectedWallet =
    typeof selectedWallets === 'string' ? undefined : selectedWallets[0]

  const [wallets] = useAtom(
    (ctx) => {
      const delugeId = ctx.spy(delugeIdAtom)
      if (!delugeId || delugeId !== model.delugeId) {
        return model.wallets
      }
      const walletIds = ctx.spy(walletIdsAtom)
      return model.wallets.filter((wallet) => walletIds.has(wallet.id))
    },
    [model.delugeId, model.wallets],
  )

  return (
    <WalletSelector
      wallets={wallets}
      onSelectWallet={(x) =>
        setSelectedWallets(x === ALL_WALLETS ? ALL_WALLETS : [x])
      }
      selectedWallet={selectedWallet}
    />
  )
}
